import { FC } from 'react';

import { isPrimaryTooth } from '@/entities/tooth';

import { ToothChartItemClickHandler, ToothItem } from '../../config/types';
import { ToothChart } from '../ToothChart';

type ToothChartMetaItemProps = {
  toothItem: ToothItem;
  handleToothClick?: ToothChartItemClickHandler;
  showApprovedStatus?: boolean;
  preview?: boolean;
  blackAndWhite?: boolean;
};

export const ToothChartMetaItem: FC<ToothChartMetaItemProps> = (props) => {
  const {
    toothItem,
    handleToothClick,
    showApprovedStatus,
    preview,
    blackAndWhite,
  } = props;

  const childItems = toothItem?.childItems;
  const isSupernumeric = (childItems?.length ?? 0) > 0;

  const primaryToothItem =
    isSupernumeric &&
    childItems?.find((childItem) => isPrimaryTooth(childItem.ISONumber));

  if (isSupernumeric && !primaryToothItem) {
    return (
      <ToothChart.SuperItem
        key={toothItem.id}
        id={toothItem.id}
        status={toothItem.status}
        ISONumber={toothItem.ISONumber}
        isLowerJaw={toothItem.isLowerJaw}
        active={toothItem.active}
        childItems={toothItem.childItems}
        onClick={handleToothClick}
        gridArea={toothItem.gridArea}
        isRemoved={toothItem.isRemoved}
        isApproved={showApprovedStatus ? toothItem.isApproved : false}
        preview={preview}
        blackAndWhite={blackAndWhite}
      />
    );
  }

  return primaryToothItem ? (
    <ToothChart.Item
      key={primaryToothItem.id}
      id={primaryToothItem.id}
      status={primaryToothItem.status}
      ISONumber={primaryToothItem.ISONumber}
      isLowerJaw={primaryToothItem.isLowerJaw}
      isRemoved={toothItem.isRemoved}
      active={primaryToothItem.active}
      childItems={primaryToothItem.childItems}
      gridArea={primaryToothItem.gridArea}
      onClick={handleToothClick}
      isApproved={showApprovedStatus ? primaryToothItem.isApproved : false}
      preview={preview}
      blackAndWhite={blackAndWhite}
    />
  ) : (
    <ToothChart.Item
      key={toothItem.id}
      id={toothItem.id}
      status={toothItem.status}
      ISONumber={toothItem.ISONumber}
      isLowerJaw={toothItem.isLowerJaw}
      isRemoved={toothItem.isRemoved}
      active={toothItem.active}
      childItems={toothItem.childItems}
      gridArea={toothItem.gridArea}
      onClick={handleToothClick}
      isApproved={showApprovedStatus ? toothItem.isApproved : false}
      preview={preview}
      blackAndWhite={blackAndWhite}
    />
  );
};
